<div class="modal-container d-flex flex-column h-100">
    <div class="modal-header border-0 justify-content-start">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body flex-grow-1 overflow-y-auto overflow-x-hidden wrapper">
        <div class="row mx-0">
            <div class="col-12 col-xl-9 px-0">
                <div class="row mx-0">
                    <div class="col-12 col-md-6 col-xl-4 pe-3 ps-0 mb-3 mb-md-0">
                        <app-input 
                        [inputLabel]="'MPN'" 
                        [inputType]="'text'" 
                        [inputValue]="formModel?.manufacturerPartNumber"
                        (inputValueEmit)="formModel.manufacturerPartNumber =$event;"
                        (parentFun)="onKeydown($event, '#description')"
                        [inputReqValidation]="true"
                       [ngClass]="{'border-red': !formModel?.manufacturerPartNumber && submitted}">
                        </app-input>
                    </div>
                    <div class="col px-3 d-none d-xl-block">
                        <app-input 
                        [inputLabel]="'Description (Max 100 characters)'" 
                        [inputType]="'text'" 
                        [inputMaxlength]="100"
                        [inputValue]="formModel?.description"
                        (inputValueEmit)="formModel.description =$event"
                        (parentFun)="onKeydown($event, '#phoneNumber')"
                        >
                        </app-input>
                    </div>
                    <div class="col pe-0 ps-0 pe-3 pe-md-0 d-block ps-md-3 d-xl-none">
                        <app-dropdown
                        [selectLabel]="'Device Package'"
                        [data]="getAllDropdown?.devicePackagingList"
                        [selectValue]="formModel?.devicePackageId"
                        (selectValueEmit)="formModel.devicePackageId = $event"
                        [required]="false"
                      >
                      </app-dropdown>
                    </div>
                </div>
                <div class="row mx-0 pt-2">
                    <div class="col-12 col-md-6 col-xl-4 px-3 d-flex justify-content-end">
                        <label for="'add-part'" class="text-semi-primary hand mb-0 font-14" (click)="openAddEditMFRModal()">+ Add MFR
                        </label>
                    </div>
                </div>
                <div class="row mx-0">
                       <div class="col-12 col-md-6 col-xl-4 pe-3 ps-0 mb-3 mb-md-0 requirement">
                        <app-input-search
                        id="typeahead-format"
                        [inputType]="'text'"
                        [inputLabel]="'MFR'"
                        [ngbTypeahead]="mfrSearch"
                        [inputValue]="mfrName"
                        (inputValueEmit)="formModel.manufacturerId  = $event;selectValueChange($event,undefined)"
                        (blur)="clearInputText()"
                        [inputReqValidation]="true"
                       [ngClass]="{'border-red':!formModel.manufacturerId && submitted}"
                      ></app-input-search>
                    </div>
                    <div class="col-4 px-3 d-none d-xl-block">
                        <app-dropdown
                        [selectLabel]="'Standard Packaging'"
                        [data]="getAllDropdown?.standardPackagingList"
                        [selectValue]="formModel?.standardPackagingId"
                        (selectValueEmit)="formModel.standardPackagingId = $event"
                        [required]="false"
                      >
                      </app-dropdown>
                    </div>
                    <div class="col-4 px-3 d-none d-xl-block">
                        <app-input 
                        [inputLabel]="'SPQ'" 
                        [inputType]="'text'" 
                        [inputValue]="formModel?.spq"
                        (inputValueEmit)="formModel.spq =$event;"
                        (parentFun)="onKeydown($event, '#description')"
                        >
                        </app-input>
                    </div>
                    <div class="col pe-0 ps-0 pe-3 pe-md-0 d-block ps-md-3 d-xl-none">
                        <app-dropdown
                        [selectLabel]="'Temp Grade'"
                        [data]="getAllDropdown?.temperatureGradeList"
                        [selectValue]="formModel?.tempGradeId"
                        (selectValueEmit)="formModel.tempGradeId  = $event"
                        [required]="false"
                      >
                      </app-dropdown>
                    </div>
                </div>
                <div class="row mx-0 py-3">
                    <div class="col-xl-4 col-md-6 col-lg-6 pe-3 ps-0 mb-3 mb-md-0">
                        <app-dropdown
                        [selectLabel]="'Part Status'"
                        [data]="getAllDropdown?.partStatusList"
                        [selectValue]="formModel?.partStatusId"
                        (selectValueEmit)="formModel.partStatusId = $event"
                        [required]="false"
                      >
                      </app-dropdown>
                 </div>
                 <div class="col-4 px-3 d-none d-xl-block">
                     <app-dropdown
                     [selectLabel]="'Device Package'"
                     [data]="getAllDropdown?.devicePackagingList"
                     [selectValue]="formModel?.devicePackageId"
                     (selectValueEmit)="formModel.devicePackageId = $event"
                     [required]="false"
                   >
                   </app-dropdown>
                 </div>
                 <div class="col-4 px-3 d-none d-xl-block">
                     <app-input 
                     [inputLabel]="'MOQ'" 
                     [inputType]="'text'" 
                     [inputValue]="formModel?.moq"
                     (inputValueEmit)="formModel.moq =$event;"
                     (parentFun)="onKeydown($event, '#description')"
                     >
                     </app-input>
                 </div>
                 <div class="col-12 col-md-6 pe-3 ps-0 d-block ps-md-3 pe-md-0 d-xl-none">
                    <app-input 
                    [inputLabel]="'SPQ'" 
                    [inputType]="'text'" 
                    [inputValue]="formModel?.spq"
                    (inputValueEmit)="formModel.spq =$event;"
                    (parentFun)="onKeydown($event, '#description')"
                    >
                    </app-input>
                </div>
             </div>
             <div class="row mx-0">
                <div class="col-xl-4 col-md-6 col-lg-6 pe-3 ps-0 mb-3 mb-md-0">
                 <app-input 
                 [inputLabel]="'Internal Part Number'" 
                 [inputType]="'text'" 
                 [inputValue]="formModel?.partNumber"
                 (inputValueEmit)="formModel.partNumber =$event;"
                 (parentFun)="onKeydown($event, '#description')"
                 >
                 </app-input>
             </div>
             <div class="col-4 px-3 d-none d-xl-block">
                 <app-dropdown
                 [selectLabel]="'Temp Grade'"
                 [data]="getAllDropdown?.temperatureGradeList"
                 [selectValue]="formModel?.tempGradeId"
                 (selectValueEmit)="formModel.tempGradeId = $event"
                 [required]="false"
               >
               </app-dropdown>
             </div>
             <div class="col-4 px-3 d-none d-xl-block">
                <app-dropdown
                [selectLabel]="'Mount Type'"
                [data]="getAllDropdown?.mountTypeList"
                [selectValue]="formModel?.mountTypeId"
                (selectValueEmit)="formModel.mountTypeId = $event"
                [required]="false"
              >
              </app-dropdown>

             </div>
             <div class="col-12 col-md-6 pe-3 ps-0 d-block ps-md-3 pe-md-0 d-xl-none">
                <app-input 
                [inputLabel]="'MOQ'" 
                [inputType]="'text'" 
                [inputValue]="formModel?.moq"
                (inputValueEmit)="formModel.moq =$event;"
                (parentFun)="onKeydown($event, '#description')"
                >
                </app-input>
            </div>
             </div>
             <div class="row mx-0 py-4 d-flex d-xl-none">
                <div class="col-12 col-sm-6 pb-4 ps-0 pe-3">
                    <app-input 
                    [inputLabel]="'Description (Max 100 characters)'" 
                    [inputType]="'text'" 
                    [inputMaxlength]="100"
                    [inputValue]="formModel?.description"
                    (inputValueEmit)="formModel.description =$event"
                    (parentFun)="onKeydown($event, '#phoneNumber')"
                    >
                    </app-input>
                </div>
                <div class="col-12 col-sm-6 pb-4 ps-0 pe-3 ps-md-3 pe-md-0">
                    <app-dropdown
                    [selectLabel]="'Mount Type'"
                    [data]="getAllDropdown?.mountTypeList"
                    [selectValue]="formModel?.mountTypeId"
                    (selectValueEmit)="formModel.mountTypeId = $event"
                    [required]="false"
                  >
                  </app-dropdown>
                </div>
                <div class="col-12 col-sm-6 ps-0 pe-3 mb-3 mb-md-0">
                    <app-dropdown
                    [selectLabel]="'Standard Packaging'"
                    [data]="getAllDropdown?.standardPackagingList"
                    [selectValue]="formModel?.standardPackagingId"
                    (selectValueEmit)="formModel.standardPackagingId = $event"
                    [required]="false"
                  >
                  </app-dropdown>
                </div>
                <div class="col-12 col-sm-6 pb-4 ps-0 pe-3 ps-md-3 pe-md-0">
                    <app-input 
                    [inputLabel]="'Notes (Max 300 characters)'" 
                    [inputType]="'text'" 
                    [inputMaxlength]="100"
                    [inputValue]="formModel?.notes"
                    (inputValueEmit)="formModel.notes = $event"
                    (parentFun)="onKeydown($event, '#phoneNumber')"
                    >
                    </app-input>
                </div>
             </div>
            </div>
            <div class="col-3 pb-1 ps-3 pe-0 d-none d-xl-block">
                <app-textarea 
                [label]="'Notes (Max 300 characters)'"
                [textareaHeight]="'15.9rem'"
                [name]="'notes'"
                [id]="'notes'"
                [maxlength]="300"
                [inputValue]="formModel.notes"
                (inputValueEmit)="formModel.notes=$event"
                ></app-textarea>
            </div>
        </div>
<!-- part details -->
        <div class="row mx-0">
            <div class="px-0">
                <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs gap-03 ms-0 d-flex align-items-center">
                    <li *ngFor="let tab of tabData" [ngbNavItem]="tab.id" class="pb-2"
                    [ngStyle]="{'border-bottom': active === tab.id ? '1px solid var(--sitewide_primary_accent_color)' : '1px solid transparent'}">
                        <div class="nav-title hand pe-0 pe-sm-3 tab-view"
                         [ngClass]="active === tab.id ? 'text-primary-color' :  'text-light-gray'"
                          (click)="activeTab(tab.id)"
                          ngbNavLink>
                          {{ tab.label }}
                        </div>
                        <ng-template ngbNavContent>
                            <ng-container *ngIf="active === 1">
                                <app-compliance-export 
                                [formModel]="formModel"
                                [getAllDropdown]="getAllDropdown"
                                [filterCheckList]="filterCheckList">
                            </app-compliance-export></ng-container>
                            <ng-container *ngIf="active === 2">
                                <app-additional-details 
                                [formModel]="formModel"
                                [getAllDropdown]="getAllDropdown">
                            </app-additional-details></ng-container>
                            <ng-container *ngIf="active === 3">
                                <app-pricing 
                                [formModel]="formModel"
                                [getAllDropdown]="getAllDropdown">
                            </app-pricing></ng-container>
                        </ng-template>
                      </li>
        
                </ul>
                <div [ngbNavOutlet]="nav" class=""></div>
            </div>
          
           </div>
          
    </div>
    <div class="modal-footer border-0 justify-content-end">
        <div class="m-0 d-flex flex-wrap justify-content-end column-gap-3 column-gap-md-3 row-gap-3">
            <app-button 
            [buttonType]="'button'" 
            [button_2]="true" 
            [buttonClass]="'button button-danger  popup-button'"
            class="" (click)="activeModal.close({title,confirm:false})"
            [buttonLable]="enumButtonName.CANCEL">
          </app-button>
           <app-button  
           [buttonType]="'button'" 
           [button_2]="true" 
           [inputReadonly]="!isDisable()"
           [buttonClass]="isDisable() ? 'button-primary button  popup-button' : 'button-info button  popup-button'"
           class="" (click)="openAddInventoryPopup()"
           [buttonLable]="title == 'Edit Part'?'Update Part & Inventory':'Add Part & Inventory'">
        </app-button>
          <app-button 
          [inputReadonly]="!isDisable()" 
          [buttonType]="'button'" 
          [button_2]="true" 
          [buttonClass]="isDisable() ? 'button-primary button  popup-button' : 'button-info button  popup-button'"
          class="" (click)="openAddConsignmentPopup()"
          [buttonLable]="title == 'Edit Part'?'Update Part & Consignment':'Add Part & Consignment'">
        </app-button>
          <app-button 
          [inputReadonly]="!isDisable()" 
          [buttonType]="'button'" 
          [button_2]="true"
          [buttonClass]="isDisable() ? 'button-primary button  popup-button' : 'button-info button  popup-button'"
          class="" [buttonLable]="title == 'Edit Part'?'Update Part':'Add Part'"
          (click)="title == 'Edit Part'?updatePart():onAddPartButtonClick()">
        </app-button>
        </div>
    </div>
</div>